import React from 'react';

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;

interface ProposalProjectImagesProps {
    proposedPropertyDataFromApi: any;
}

export function ProposalProjectImages({ proposedPropertyDataFromApi }: ProposalProjectImagesProps) {
        
    return (
            <>
                {proposedPropertyDataFromApi?.projectImages?.map((project: any) =>
                    <>
                        {project.resImages.map((resImage: any, indx: number) =>
                            <table className="table-outer-area page-break"
                                style={{
                                    // backgroundImage: `url(${require("../../../assets/images/proposal-table-shadow.png")})`,
                                    backgroundImage: `url(${proposalTableShadow})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "bottom",
                                    backgroundSize: "cover",
                                    marginTop: "15px",
                                    minHeight: "794px",
                                }}
                                width="100%"
                                cellPadding="10"
                                cellSpacing="0"
                                key={indx}
                            >
                                <tbody>
                                    <tr>
                                        <td align="right">
                                            <img
                                                width={110}
                                                src={logoIcon}
                                                alt="property image"
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td width="100%" className="pl-40"
                                            style={{
                                                color: "#021D77",
                                                marginTop: "-57px",
                                                display: "block",
                                            }}
                                        >
                                            <br />
                                            <div style={{ display: 'flex', }}>
                                                <strong
                                                    style={{ fontSize: "25px", fontWeight: 700, maxWidth: '80%', flexShrink: 0 }}
                                                >
                                                    {project?.projectName}
                                                </strong>
                                                <div style={{ height: '4px', width: '100%', backgroundColor: '#C39864', marginTop: '18px', marginLeft: '10px' }}></div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ padding: "0" }}>
                                            <table
                                                cellPadding="20"
                                                cellSpacing="0"
                                                width="100%"
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <table
                                                                width="100%"
                                                                cellPadding="0"
                                                                cellSpacing="0"
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <table
                                                                                width="100%"
                                                                                cellPadding="0"
                                                                                cellSpacing="12"
                                                                                style={{
                                                                                    borderCollapse: "separate",
                                                                                }}
                                                                            >
                                                                                <tbody>
                                                                                    <div className="text-center">
                                                                                        <u style={{
                                                                                            fontSize: "22px",
                                                                                            color: "#8FA9D4",
                                                                                            fontWeight: 700,
                                                                                        }}>{resImage?.imageCatType?.toUpperCase()} </u>
                                                                                    </div>
                                                                                    <tr>
                                                                                        <td align="center">
                                                                                            <img className="floor-img"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    maxWidth: "800px",
                                                                                                    objectFit: "contain",
                                                                                                    maxHeight: "600px",
                                                                                                    marginTop: "10px",
                                                                                                }}
                                                                                                src={resImage?.projectImage}
                                                                                                alt="property_image"
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            height="50"
                                            style={{ backgroundColor: "#021D77" }}
                                        ></td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </>
                )}
            </>
    );
}